export const SET_OPERATION_FILTER = 'SET_OPERATION_FILTER';
export const SET_SELECTED_JAG = 'SET_SELECTED_JAG';
export const SET_OPERATION_FILTER_LABEL = 'SET_OPERATION_FILTER_LABEL';
export const SET_OPERATIONS = 'SET_OPERATIONS';
export const SET_POLY_LAYER = 'SET_POLY_LAYER';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const RESET = 'RESET';
